import { CommonMainPage } from '../../widgets/utility/CommonMainPage'
import { ProjectsTable } from './widgets/projects-table/ProjectsTable'
import React, { useEffect, useState } from 'react'
import { Notify } from '../../shared/components/text/notify/Notify'
import { useAppSelector } from '../../app/store/hooks/Redux'
import { selectNotifications, selectTariffDetails } from '../../app/store/reducers/AuthSlice'
import { SetUpTracking } from '../../shared/components/notifications/set-up-tracking/SetUpTracking'
import { INotifications } from '../../app/store/models/User.model'
import {
  usePostSiteHideNotificationMutation,
  usePostUserGetStripePortalLinkMutation,
} from '../../app/api'
import { useCookies } from 'react-cookie'
import clsx from 'clsx'

import styles from './ProjectsPage.module.scss'
import { useTranslation } from 'react-i18next'

export const ProjectsPage = () => {
  const { t } = useTranslation()
  const notifications = useAppSelector(selectNotifications)
  const tariffDetails = useAppSelector(selectTariffDetails)
  const [cookies, setCookies] = useCookies(['first_affiliate_rule_setup'])
  const [notification, setNotification] = useState<INotifications>()

  const [stripePortal] = usePostUserGetStripePortalLinkMutation()
  const [hideNotification] = usePostSiteHideNotificationMutation()

  const handleHideNotification = () => {
    if (notification) {
      hideNotification({ id: notification.id })
      setCookies('first_affiliate_rule_setup', false)
    }
  }

  useEffect(() => {
    if (notifications && notifications.some(({ type }) => type === 'first_affiliate_rule_setup')) {
      const notification = notifications.find(({ type }) => type === 'first_affiliate_rule_setup')

      setNotification(notification)

      if (cookies.first_affiliate_rule_setup !== false) {
        setCookies('first_affiliate_rule_setup', true)
      }
    }
  }, [notifications])

  return (
    <CommonMainPage hint={t('navigation.hint.projects')} title={t('navigation.projects')}>
      {tariffDetails?.tariff?.stripe_cancel_at &&
        !tariffDetails?.tariff?.is_subscription_expired && (
          <div className={clsx(styles.notifyWrapper)}>
            <Notify>
              <p className={clsx(styles.notifyText)}>
                Your subscription will be canceled on {tariffDetails?.tariff?.stripe_cancel_at}. If
                you change your mind, you can keep it active{' '}
                <button
                  className={clsx(styles.notifyLink)}
                  onClick={() => {
                    stripePortal()
                      .unwrap()
                      .then((response) => {
                        if (response.data?.url) window.location.href = response.data.url
                      })
                      .catch(() => undefined)
                  }}
                >
                  here
                </button>
                .
              </p>
            </Notify>
          </div>
        )}
      <section className={clsx(styles.wrapper)}>
        <ProjectsTable />
        {!!notification && !!cookies.first_affiliate_rule_setup && (
          <SetUpTracking
            project={notification.project_id as number}
            show={!!notification}
            onHide={handleHideNotification}
          />
        )}
      </section>
    </CommonMainPage>
  )
}
